import React from 'react';
import styled from "styled-components";
import {MdMenu, MdShoppingCart} from "react-icons/md";
import {Link} from 'react-router-dom';
import AccountPopover from '../../components2/header/AccountPopover';
import { useSidebarContext } from '../../context/sidebar/sidebar_context';
import { useSelector } from 'react-redux';
import { Button, Stack, Typography } from '@mui/material';
import { useCartContext } from '../../context/cart/cart_context';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const Navbar = () => {
  const {total_items} = useCartContext();
  const {openSidebar} = useSidebarContext();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const firstName  = localStorage.getItem('firstName');

  return (
    <NavbarWrapper className = "bg-white flex">
      <div className='container w-100'>
        <div className='brand-and-toggler flex flex-between w-100'>
          <Link to = "/" className='navbar-brand text-uppercase ls-1 fw-8'>
           <Typography color='error' variant= 'h3' fontWeight={800}>Test Masters</Typography>
          </Link>

          <Stack direction="row" sx={{ display: { xs: 'none', sm: 'block' } }} spacing={{ xs: 1.5, md: 2.5 }}>
          <div className='navbar-btns flex'>
            <Link to = "/allcourses2/cart" className='cart-btn'>
              <ShoppingCartIcon color='warning' fontSize='large' />
              <span className='item-count-badge'>{total_items}</span>
            </Link>
            {isAuthenticated || firstName ? (
              <AccountPopover />
            ) : (
                
              <Link to="/login" className='login-btn'>
                <Button variant='contained' color='success'>
                Login
                </Button>
              </Link>
            )}
           {/*} <Button size='large' type = "button" className='sidebar-open-btn' onClick={() => openSidebar()}>
              <MdMenu size='large' color='success'/>
            </Button> */}
          </div>
          </Stack>
        </div>
      </div>
    </NavbarWrapper>
  )
}

const NavbarWrapper = styled.nav`
  height: 80px;
  box-shadow: rgba(50, 50, 93, 0.15) 0px 16px 12px -2px, rgba(0, 0, 0, 0.2) 0px 3px 7px -3px;

  .navbar-brand{
    font-size: 23px;
    span{
      color: var(--clr-orange);
    }
  }
  .cart-btn{
    margin-right: 18px;
    font-size: 23px;
    position: relative;
    .item-count-badge{
      background-color: var(--clr-orange);
      position: absolute;
      right: -10px;
      top: -10px;
      font-size: 12px;
      font-weight: 700;
      display: block;
      width: 23px;
      height: 23px;
      color: var(--clr-white);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .sidebar-open-btn{
    transition: all 300ms ease-in-out;
    &:hover{
      opacity: 0.7;
    }
  }
`;

export default Navbar;